fragment McfxCompanyFragment on McfxCompany {
    id
    name
    initials
    url
    phones
    industry {
        id
        name
    }
    numEmployees
    annualRevenue {
        amount
    }
    isLocked
    createdTime
    convertedTime
    unlockTime
    lastSeenTime
    wasConvertedAutomatically
    numVisits
    totalVisitDuration
    relatedAccount {
        id
        htmlUrlPath
        leads {
            edges {
                node {
                    id
                    name
                    contacts {
                        primaryEdge {
                            node {
                                id
                                name
                                htmlUrl
                            }
                        }
                    }
                    accounts {
                        primaryEdge {
                            node {
                                id
                                name
                                htmlUrl
                            }
                        }
                    }
                    htmlUrl
                    htmlUrlPath
                    avatarUrl
                    status
                    value {
                        formattedValue {
                            formatted
                            prefix
                            suffix
                            value
                        }
                    }
                }
            }
        }
    }
    primaryAddress {
        fullAddress
        region
        postalCode
        coordinates {
            latitude
            longitude
            accuracy
        }
    }
}
